import { render, staticRenderFns } from "./checkbox-renderer.vue?vue&type=template&id=7b10dcaa&scoped=true"
import script from "./checkbox-renderer.vue?vue&type=script&lang=js"
export * from "./checkbox-renderer.vue?vue&type=script&lang=js"
import style0 from "./checkbox-renderer.vue?vue&type=style&index=0&id=7b10dcaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b10dcaa",
  null
  
)

export default component.exports